import { Button } from "@/components/ui/button";
import { Sparkles, Globe } from "lucide-react";
import { IMAGES } from "@/constants/landingAssets";

export default function HeroSection({ t, navigate, scrollTo }) {
  return (
    <section id="hero" className="pt-24 pb-16 lg:pt-32 lg:pb-24" data-testid="hero-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-[#CDA34F]/10 px-4 py-1.5 rounded-full">
              <Sparkles className="w-4 h-4 text-[#CDA34F]" />
              <span className="text-sm font-bold text-[#CDA34F] uppercase tracking-wider">{t.hero.badge}</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-[3.25rem] font-extrabold text-gray-900 leading-[1.15] tracking-tight">{t.hero.title}</h1>
            <p className="text-lg text-gray-600 leading-relaxed max-w-lg">{t.hero.subtitle}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button onClick={() => navigate("/login")} className="h-14 px-8 bg-[#CC0000] hover:bg-[#a30000] text-white font-bold text-base uppercase tracking-wide rounded-lg" data-testid="hero-cta-trial">{t.hero.cta1}</Button>
              <Button onClick={() => scrollTo("demo")} variant="outline" className="h-14 px-8 border-2 border-[#CDA34F] text-[#CDA34F] hover:bg-[#CDA34F]/5 font-bold text-base uppercase tracking-wide rounded-lg" data-testid="hero-cta-demo">{t.hero.cta2}</Button>
            </div>
            {t.hero.ecosystemTags?.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {t.hero.ecosystemTags.map((tag) => (
                  <span key={tag} className="text-xs font-semibold bg-gray-100 text-gray-500 px-3 py-1 rounded-full uppercase tracking-wide">
                    {tag}
                  </span>
                ))}
              </div>
            )}
            <div className="flex flex-col gap-3">
              {t.hero.microcopy && (
                <p className="text-sm font-semibold text-gray-700">{t.hero.microcopy}</p>
              )}
              <div className="flex flex-wrap items-center gap-3">
                <div className="inline-flex items-center gap-2 bg-gray-50 border border-gray-200 px-3 py-1.5 rounded-lg">
                  <Globe className="w-3.5 h-3.5 text-[#CDA34F]" />
                  <span className="text-xs font-mono text-gray-600">seurestaurante<span className="text-[#CDA34F] font-bold">.kaisosystem.com</span></span>
                </div>
                {t.hero.social && (
                  <span className="text-xs text-gray-500 flex items-center gap-1">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block"></span>
                    {t.hero.social}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-center lg:justify-end">
            <img src={IMAGES.hero} alt="Dashboard" className="w-full max-w-lg" />
          </div>
        </div>
      </div>
    </section>
  );
}
